import { ExtractRouteParams, generatePath } from 'react-router'

export enum ProfileRoutes {
  MAIN = '/configuration/lms-profiles',
  CREATE = '/configuration/lms-profiles/create',
  EDIT = '/configuration/lms-profiles/edit/:id',
}

export type RouteProfileEditParams = {
  id: string
}

export const createRouteProfileEdit = (
  params: ExtractRouteParams<ProfileRoutes.EDIT>
) => generatePath(ProfileRoutes.EDIT, params)
